module.exports = __webpack_public_path__ + "img/sty_1.3d11275f.png";